import React from 'react';

const Phone = () => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 58">
    <path
      d="M7.143 3.572A7.15 7.15 0 0 0 0 10.714V46.43a7.15 7.15 0 0 0 7.143 7.142h35.714A7.15 7.15 0 0 0 50 46.43V10.714a7.15 7.15 0 0 0-7.143-7.142H7.143Zm10.123 10.792a2.228 2.228 0 0 1 2.645 1.295l2.232 5.357c.38.915.111 1.964-.648 2.589L18.75 25.86a18.79 18.79 0 0 0 8.962 8.962l2.255-2.757a2.242 2.242 0 0 1 2.589-.647l5.357 2.232a2.234 2.234 0 0 1 1.295 2.645l-1.34 4.91a2.23 2.23 0 0 1-2.154 1.652c-13.805 0-25-11.194-25-25 0-1.004.67-1.886 1.64-2.154l4.912-1.34Z"
      fill="#fff"
    />
  </svg>
);

export default Phone;
